import { render, staticRenderFns } from "./HistoryAlarm.vue?vue&type=template&id=50eb8054&scoped=true&"
import script from "./HistoryAlarm.vue?vue&type=script&lang=js&"
export * from "./HistoryAlarm.vue?vue&type=script&lang=js&"
import style0 from "./HistoryAlarm.vue?vue&type=style&index=0&id=50eb8054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eb8054",
  null
  
)

export default component.exports